import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import groupQueryKeys from 'app/hooks/queries/group/groupQueryKeys';
import { useMutation, useQueryClient } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { GroupCreateDoc } from 'types/group';

export const useCreateGroup = () => {
  const queryClient = useQueryClient();
  const authState = useAuthSelector();
  return useMutation(
    (groupCreateDoc: GroupCreateDoc) =>
      sdk.group.mutate.create(groupCreateDoc, authState?.auth_token),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(groupQueryKeys.all);
        await queryClient.invalidateQueries(callflowQueryKeys.all);
      },
    },
  );
};

export const useCreateGroupDev = () => {
  const authState = useAuthSelector();
  return useMutation((groupCreateDoc: GroupCreateDoc) =>
    sdk.group.mutate.createDev(groupCreateDoc, authState?.auth_token),
  );
};
